module.exports = __webpack_public_path__ + "img/6@2x.b202dd2f.png";